// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__UR5tW","bordered":"styles_bordered__Khshq","autoWidth":"styles_autoWidth__xj7PX"};